import useDarkMode from './use-dark-mode';
export default useDarkMode;